import { render, staticRenderFns } from "./LoginLector.vue?vue&type=template&id=0bfca1bc&"
import script from "./LoginLector.vue?vue&type=script&lang=js&"
export * from "./LoginLector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports